export const linkIlok = (
    state = { },
    action
) => {
    switch (action.type) {
        default:
            return state;
    }
};